import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

// El encabezado, el pie y el ritmo de 16 px los da GuideDrawer; acá sólo el resumen de lo que se exporta.
export const useServiceExportDrawerStyles = makeStyles({
  summaryBox: {
    backgroundColor: 'var(--ichtys-bg)',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalM),
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS
  },
  summaryLine: {
    color: 'var(--ichtys-text-secondary)',
    fontSize: tokens.fontSizeBase300
  }
});
